var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.42188C10.5 4.76503 9.15685 3.42188 7.5 3.42188C5.84315 3.42188 4.5 4.76503 4.5 6.42188V18.4218C4.5 20.0787 5.84315 21.4218 7.5 21.4218C9.15685 21.4218 10.5 20.0787 10.5 18.4218V6.42188Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.42188C20.5 4.76503 19.1569 3.42188 17.5 3.42188C15.8431 3.42188 14.5 4.76503 14.5 6.42188V18.4218C14.5 20.0787 15.8431 21.4218 17.5 21.4218C19.1569 21.4218 20.5 20.0787 20.5 18.4218V6.42188Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBtn);
export default __webpack_public_path__ + "static/media/pause_btn.954ed04342ebe435294cb98affc74e24.svg";
export { ForwardRef as ReactComponent };